import { fence } from "@ext/markdown/elements/codeBlockLowlight/render/model/codeBlock";
import { color } from "@ext/markdown/elements/color/render/model/color";
import { highlight } from "@ext/markdown/elements/highlight/render/model/schema";
import { article } from "../../../../elements/article/render/article";
import { code } from "../../../../elements/code/render/model/code";
import { em } from "../../../../elements/em/render/em";
import { heading } from "../../../../elements/heading/render/model/heading";
import { hr } from "../../../../elements/hr/render/hr";
import { image } from "../../../../elements/image/render/image";
import { link } from "../../../../elements/link/render/model/link";
import { li, ol, ul } from "../../../../elements/list/render/list";
import { paragraph } from "../../../../elements/paragraph/paragraph";
import { strikethrough } from "../../../../elements/strikethrough/render/strikethrough";
import { strong } from "../../../../elements/strong/render/strong";
import { sub } from "../../../../elements/sub/sub";
import { table, tbody, td, thead, tr } from "../../../../elements/table/render/model/table";
import PrivateParserContext from "../../../Parser/ParserContext/PrivateParserContext";
import { Schema } from "../Markdoc";

export default function getNodeElementRenderModels(context?: PrivateParserContext): Record<string, Schema> {
	const contextelements = context ? getContextNodeElementRenderModels(context) : {};

	return {
		link: link(context),
		strikethrough,
		paragraph,
		article,
		heading,
		strong,
		fence,
		table,
		color,
		highlight,
		td,
		thead,
		tbody,
		code,
		sub,
		em,
		tr,
		hr,
		ul,
		ol,
		li,
		...contextelements,
	};
}

function getContextNodeElementRenderModels(context: PrivateParserContext): Record<string, Schema> {
	return {
		image: image(context),
	};
}
